
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiVesselTypeCargoFilled as ObiVesselTypeCargoFilledElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-vessel-type-cargo-filled.js';
 
 
 

 
 export const ObiVesselTypeCargoFilled = createComponent({
   react: React,
   tagName: 'obi-vessel-type-cargo-filled',
   elementClass: ObiVesselTypeCargoFilledElement,
   events: {
     
   }
  });
 
 